<template>
    <div class="meeting-status">
        <template v-if="apiFailed">
            <PermissionRed></PermissionRed>
            <span style="font-size: 16px">
                Your call with {{ patientName }} failed due to an error from our end.<br/>
                Please click on the button to Try Again
            </span>
            <button class="try-again-button" @click="tryAgain">
                Try Again
            </button>
        </template>
        <template v-else-if="!permissionError">
            <div :class="['video-permission', browserAgent]" v-if="askingPermissions">
                <i class="arrow-icon">&#10229;</i>
                <span>
                    Hit Allow in the dialogue box to initiate this call
                </span>
            </div>
            <LoadSpinner class="loading-spinner"></LoadSpinner>
            <span>
                Initiating call with
                <br/>
                {{ patientName }}
            </span>
        </template>
        <template v-else>
            <PermissionRed></PermissionRed>
            <span>Call initiation with {{ patientName }}</span>
            <strong>failed</strong>
            <span class="error">
                You need to give Microphone and Camera permissions to initiate the call
            </span>
        </template>
    </div>
</template>

<script>
import LoadSpinner from '../component/icon/LoadSpinner'
import MeetingIcons from './icon'

/**
 * Component to show status of call,
 * wether initiating or some error, etc.
 */
export default {
    name: 'meeting-status',

    props: {
        /**
         * Name of the patient for the call
         */
        patientName: {
            type: String
        },
        /**
         * `true` if browser permissions
         * get blocked
         */
        permissionError: {
            type: Boolean,
            default: false
        },
        /**
         * `true` if asking for permissions
         */
        askingPermissions: {
            type: Boolean,
            default: false
        },
        /**
         * True if there was any problem 
         * creating meeting
         */
        apiFailed: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        browserAgent() {
            if(navigator.userAgent.indexOf("Firefox") > -1)
                return 'firefox'
            else
                return ''
        }
    },

    methods: {
        /**
         * Reload the page to try loading again
         */
        tryAgain() {
            location.reload()
        }
    },

    components: {
        LoadSpinner,
        ...MeetingIcons
    }
}
</script>

<style lang="scss">
@import "@/module/app/theme/color.scss";

.meeting-status {
    position: absolute;
    left: 0;
    width: 100%;
    height: 400px;
    top: calc(50% - 200px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .video-permission {
        position: fixed;
        left: 500px;
        top: 0px;
        color: $white-color;
        padding-top: 80px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        &.firefox {
            left: 650px;
            top: 100px;
        }
        i.arrow-icon {
            font-size: 50px;
            font-style: normal;
        }
        span {
            width: 200px;
            padding-left: 20px;
            font-size: 16px;
            line-height: 20px;
            font-weight: bold;
            text-align: left;
        }
    }
    .loading-spinner {
        height: 25px;
        width: 25px;
    }
    & > span {
        margin-top: 12px;
        font-size: 18px;
        line-height: 24px;
        max-width: 450px;
        color: $white-color;
        text-align: center;
        &.error {
            margin-top: 24px;
            margin-bottom: 32px;
            font-size: 18px;
        }
    }
    & > strong {
        font-size: 24px;
        line-height: 30px;
        font-weight: bold;
        color: $white-color;
        display: block;
    }
    .try-again-button {
        margin-top: 24px;
        background-color: transparent;
        font-size: 16px;
        color: $white-color;
        padding: 10px 24px;
        border: 1px solid $grey-100;
    }
}
</style>
